import $ from 'jquery';
import buttonsGetLine from '../Button/buttonsGetLine';

export default (container = document) => {
  $('[data-rte-banner]', container).each((i, banner) => {
    const $banner = $(banner);

    // weird things happen when you use the same format as shopify...
    const possibly_json = $banner.find('[data-settings]').html();
    const json = possibly_json.replace('// <![CDATA[', '').replace('// ]]>', '');
    const {settings} = JSON.parse(json);
    let content_animation = '';
    let announcements_placeholder = '';
    let banner_preheading = '';
    let banner_heading = '';
    let banner_subheading = '';
    let banner_description = '';
    let banner_wysiwyg = '';
    let buttons_content = '';

    if (settings.content_animation !== 'none') {
      content_animation = ` Animate Animate--${settings.content_animation} `;
    }

    if (window.theme && window.theme.settings && window.theme.settings.preheader_enabled) {
      announcements_placeholder = 'AnnouncementsBarPlaceholder--hide-desktop';
    }

    if (settings.preheading) {
      banner_preheading = `              
      <h2 class="Banner__preheading">
        ${settings.preheading}
      </h2>
      `;
    }

    if (settings.heading) {
      banner_heading = `<h3 class="Banner__heading ${settings.heading_size || ''} ${settings.heading_style || ''}">${settings.heading}</h3>`;

      if (settings.heading_style) {
        banner_heading = `<div style="margin-bottom: 20px;">${banner_heading}</div>`;
      }
    }

    if (settings.subheading) {
      banner_subheading = `
        <h2 class="Banner__subheading ${settings.subheading_size || ''} ${settings.subheading_style || ''}">
          ${settings.subheading}
        </h2>
      `;

      if (settings.subheading_style) {
        banner_subheading = `<div style="margin-bottom: 10px;">${banner_subheading}</div>`;
      }
    }

    if (settings.wysiwyg) {
      banner_wysiwyg = `
        <div class="Banner__wysiwyg">${settings.wysiwyg}</div>
      `;
    }

    if (settings.description) {
      banner_description = `
        <div class="Banner__description">
          ${settings.description}
        </div>
      `;
    }

    [1, 2, 3].forEach((num) => {
      if (!settings[`button_text_${num}`]) { return; }

      const button_text = settings[`button_text_${num}`] || '';
      const button_style = settings[`button_style_${num}`] || '';
      const button_url = settings[`button_url_${num}`] || '';

      buttons_content += `
        <div class="Banner__button">
          <a href="${button_url}"  class="Button Button--${button_style}">
            ${button_text}
          </a>
        </div>
      `;
    });

    if (buttons_content) {
      buttons_content = `
        <div class="Banner__buttons">
          ${buttons_content}
        </div>
      `;
    }


    const banner_content = `
      <div class="Banner__content Overlay__content">
        <div class="Section__container ${content_animation}">
          <div class="Banner__content-main">
            <div class="AnnouncementsBarPlaceholder ${announcements_placeholder}"></div>
            ${banner_preheading}
            ${banner_heading}
            ${banner_subheading}
            ${banner_description}
            ${banner_wysiwyg}
            ${buttons_content}
          </div>
        </div>
      </div>
    `;

    const section_id = `RteBanner--${i}`;
    const banner_height = settings.banner_height || 500;
    const banner_height_mobile = settings['banner_height--mobile'] || banner_height;
    const background_position = settings.background_position || 'center';
    const background_position_mobile = settings['background_position--mobile'] || background_position;
    const max_width = settings.max_width || 900;
    let outside_mobile_styles = '';

    if (settings['outside--mobile']) {
      outside_mobile_styles = `
        @media only screen and (max-width: 767px) {
          .rte #Section${section_id} .Banner__content {
            text-align: center;
          }
    
          .rte #Section${section_id} .Banner .Banner__description,
          .rte #Section${section_id} .Banner .Banner__buttons {
            display: none;
          }
        }
      `;
    }

    let height_type = 'height';
    if (settings.responsive_height) {
      height_type = 'min-height';
    }

    const banner_styles = `
      <style>
        .rte #Section${section_id} .Banner {
          ${height_type}: ${banner_height}px;
        }
        @media only screen and (max-width: 767px) {
          .rte #Section${section_id} .Banner {
            ${height_type}: ${banner_height_mobile}px;
          }
        }

        .rte #Section${section_id} .Banner__image--desktop {
          background-position: ${background_position};
        }

        .rte #Section${section_id} .Banner__image--mobile {
          background-position: ${background_position_mobile};
        }

        .rte #Section${section_id} .Section__container {
          padding-top: 0;
          padding-bottom: 0;
        }

        .rte #Section${section_id} .Section__container,
        .rte #Section${section_id} p,
        .rte #Section${section_id} h1,
        .rte #Section${section_id} h2,
        .rte #Section${section_id} h3,
        .rte #Section${section_id} h4,
        .rte #Section${section_id} h5,
        .rte #Section${section_id} h6,
        #sectionINF-ArticleContent #Section${section_id} p,
        #sectionINF-ArticleContent #Section${section_id} h1,
        #sectionINF-ArticleContent #Section${section_id} h2,
        #sectionINF-ArticleContent #Section${section_id} h3,
        #sectionINF-ArticleContent #Section${section_id} h4,
        #sectionINF-ArticleContent #Section${section_id} h5,
        #sectionINF-ArticleContent #Section${section_id} h6 {
          max-width: ${max_width}px;
          ${settings.alignment.indexOf('left') === -1 ? 'margin-left: auto;' : 'margin-left: 0;'}
          ${settings.alignment.indexOf('right') === -1 ? 'margin-right: auto;' : 'margin-right: 0;'}
        }

        ${outside_mobile_styles}
      </style>
    `;

    let outside_mobile_content = '';

    if (settings['outside--mobile']) {
      outside_mobile_content = `
        <div class="Banner__outside Banner__outside--mobile ${content_animation}">
          ${banner_description}
          ${buttons_content}
        </div>
      `;
    }

    let section_animation = '';
    let animation = '';
    const image = settings.image || '';
    const image_mobile = settings['image--mobile'] || image;
    const alignment = settings.alignment || 'center';
    const overlay = settings.overlay || 'light-text';

    if (settings.section_animation !== 'none') {
      section_animation = ` Animate Animate--${settings.section_animation} `;
    }

    if (settings.animation !== 'none') {
      animation = ` Animate--${settings.animation} `;
    }

    const banner_section = `
      <section
        id="Section${section_id}" 
        data-section-id="${section_id}" 
        data-section-type="INF-CollectionBanner" 
        class="Section ${section_animation}"
        >
        <div class="Banner">
          <div class="Banner__image Banner__image--desktop AnimateOnLoad ${animation}" style="background-image: url('${image}');">
            <img src="${image}" onLoad="elementLoaded(this);" style="display: none;">
          </div>
          <div class="Banner__image Banner__image--mobile AnimateOnLoad ${animation}" style="background-image: url('${image_mobile}');">
            <img src="${image_mobile}" onLoad="elementLoaded(this);" style="display: none;">
          </div>
          <div class="Overlay Overlay--${alignment} Overlay--${overlay}">
            <div class="Overlay__background"></div>
            ${banner_content}
          </div>
          <div class="Banner__placeholder">
            ${banner_content} 
          </div>
        </div>
        ${banner_styles}
      </section>
      ${outside_mobile_content}
    `;
    
    $banner.html(banner_section);
    buttonsGetLine();
  });
};